<div class="Title">
    <div class="khali"></div>
    <h2>گزارش اشکال جلسه </h2>
    <img (click)="onClosebottomSheet()" src="../../../../assets/icons/Times.svg">
</div>
<main>

    <form [formGroup]="sendReportForm">
        <div class="type-problem" *ngFor="let option of reportOptions">
            <div class="report-option">
                <mat-checkbox class="checkbox checkbox-blue" formControlName="reportEnum"
                    (change)="getTestReportEnum(option)">
                    <h2> {{option?.title}}</h2>
                    <span>
                        {{option?.sub_title}}
                    </span>
                </mat-checkbox>
            </div>
        </div>
        <textarea class="textarea item" formControlName="reportDescription"
            placeholder="لطفا با توضیح کامل و دقیق به ما کمک کن تا سریع تر مشکلات رو حل کنیم" matInput
            cdkAutosizeMinRows="1" cdkAutosizeMaxRows="12"></textarea>
        <!-- <input type="submit" value="ثبت اشکال" /> -->
        <app-tik-btn (click)="sendReport()" [btnClass]="'btn-green'" [btnLoading]="btnSkeleton" [btnText]="'ثبت اشکال'"
            fxFlex="100"></app-tik-btn>
    </form>
</main>